export default __webpack_public_path__ + "static/media/Punto_08_Piazza_della_Repubblica_ENG_Def.5ea83905.aac";